import { Box, Divider } from '@mui/material';

import HeroSlider from '../../sections/client/home/HeroSlider';
import HomeProductSection from '../../sections/client/home/HomeProductSection';
import BuyingGuideSection from '../../sections/client/home/BuyingGuideSection';

export default function HomePage() {
  return (
    <Box>
      <HeroSlider />

      <HomeProductSection
        title="En tendencia"
        subtitle="Una selección de nuestro catálogo, distinta en cada visita."
        sort="random"
        limit={8}
        viewAllHref="/catalogo"
      />

      <Divider />

      <HomeProductSection
        title="Lo más vendido"
        subtitle="Los productos que más eligen nuestros clientes."
        sort="best_selling"
        limit={8}
        viewAllHref="/catalogo"
      />

      <BuyingGuideSection />

      <HomeProductSection
        title="Lo último en tecnología"
        subtitle="Las novedades más recientes de nuestro catálogo."
        sort="latest"
        limit={8}
        viewAllHref="/catalogo"
      />
    </Box>
  );
}
